import MyActivity from './MyActivity'
export default MyActivity
